// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "*{padding:0;margin:0}#app{min-width:1366px}", ""]);
// Exports
module.exports = exports;
